// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { defineCustomElements } from '@siemens/ix-brand-theme/loader';
import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
import * as agGrid from 'ag-grid-community';
import { getIxTheme } from '@siemens/ix-aggrid';
import { addIcons } from '@siemens/ix-icons';
import {
  iconWarning,
  iconWarningRhombFilled,
  iconClose,
  iconCardLayout,
  iconUserManagement,
  iconProductManagement,
  iconUserSettings,
  iconExport,
  iconCogwheel,
  iconMail,
  iconMailFilled,
  iconCheck,
  iconCancel,
  iconPen,
  iconTrashcan,
  iconCopy,
  iconUploadDocumentNote,
  iconToBePublished,
  iconChevronUp,
  iconChevronDown,
  iconDetails,
  iconDocument,
  iconAnomalyFound,
  iconMinimize,
  iconMaximize,
  iconProjectNew,
  iconSuccess,
  iconCirclePlayFilled,
  iconCircleFilled,
  iconContextMenu
} from '@siemens/ix-icons/icons';

addIcons({
  iconWarning,
  iconWarningRhombFilled,
  iconClose,
  iconCardLayout,
  iconUserManagement,
  iconProductManagement,
  iconUserSettings,
  iconExport,
  iconCogwheel,
  iconMail,
  iconMailFilled,
  iconCheck,
  iconCancel,
  iconPen,
  iconTrashcan,
  iconCopy,
  iconUploadDocumentNote,
  iconToBePublished,
  iconChevronUp,
  iconChevronDown,
  iconDetails,
  iconDocument,
  iconAnomalyFound,
  iconMinimize,
  iconMaximize,
  iconProjectNew,
  iconSuccess,
  iconCirclePlayFilled,
  iconCircleFilled,
  iconContextMenu
});

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: getIxTheme(agGrid) });

defineCustomElements();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

